import { Controller } from "@hotwired/stimulus"

// Generic CMS-index "batch select" — for pages where the user ticks a bunch
// of rows and clicks an action button to apply some operation.
//
// Provides:
//   - `toggleAll`  — fired by the "select all" checkbox, toggles all
//                    `item` targets.
//   - `submit`     — validates that at least one item is checked, then
//                    submits the form referenced by `formIdValue`. The
//                    triggering element can carry these dataset overrides:
//                      - `data-action-override="/some/path"` swaps the
//                        form's action attribute first.
//                      - `data-hidden-name="…" data-hidden-value="…"`
//                        injects a hidden field (used for routing the same
//                        form through different server-side operations,
//                        e.g. feedbacks update_action=readed/destroy).
//
// Bonus: if the global jQuery `shiftSelectable` plugin is available, it's
// applied to the item targets on connect — preserves the shift+click range
// selection UX that the old inline jQuery script provided.
//
// Usage:
//   <div data-controller="batch-select"
//        data-batch-select-form-id-value="BatchChangeForm"
//        data-batch-select-empty-message-value="Нет выбранных материалов!">
//     <input type="checkbox" data-batch-select-target="all"
//            data-action="change->batch-select#toggleAll">
//     <form id="BatchChangeForm">
//       <% items.each do |item| %>
//         <input type="checkbox" name="checked_ids[]" value="<%= item.id %>"
//                data-batch-select-target="item">
//       <% end %>
//     </form>
//     <button data-action="click->batch-select#submit">Apply</button>
//   </div>
export default class extends Controller {
  static targets = ["item", "all"]
  static values  = {
    formId:       String,
    emptyMessage: { type: String, default: "Нет выбранных элементов" }
  }

  connect() {
    if (window.jQuery && window.jQuery.fn.shiftSelectable && this.hasItemTarget) {
      window.jQuery(this.itemTargets).shiftSelectable()
    }
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.itemTargets.forEach(cb => { cb.checked = checked })
  }

  submit(event) {
    event.preventDefault()

    const anyChecked = this.itemTargets.some(cb => cb.checked)
    if (!anyChecked) {
      alert(this.emptyMessageValue)
      return false
    }

    const form = document.getElementById(this.formIdValue)
    if (!form) return false

    const actionOverride = event.currentTarget.dataset.actionOverride
    if (actionOverride) form.action = actionOverride

    const hiddenName = event.currentTarget.dataset.hiddenName
    if (hiddenName) {
      const input = document.createElement("input")
      input.type  = "hidden"
      input.name  = hiddenName
      input.value = event.currentTarget.dataset.hiddenValue || ""
      form.appendChild(input)
    }

    form.submit()
    return false
  }
}
